export const fontSize = 12

export const fontFamily = ['Inter', '-apple-system', 'Verdana'].join(',')

const typography = {
  body1: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '20px',
  },
  button: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
    textTransform: 'none',
  },
  fontFamily,
  fontSize,
  h1: {
    fontSize: 24,
    fontWeight: 400,
    lineHeight: '40px',
  },
  h2: {
    fontSize: 20,
    fontWeight: 400,
    lineHeight: '32px',
  },
  h3: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '32px',
  },
  h4: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px',
  },
  h5: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
  },
  h6: {
    fontSize: 10,
    fontWeight: 600,
    lineHeight: '16px',
  },
  label: {
    fontFamily,
    fontSize: 10,
    fontWeight: 500,
    lineHeight: '16px',
  },
  overline: {
    fontSize: 10,
    fontWeight: 500,
    lineHeight: '16px',
  },
} as const

export default typography
